import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.split";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
import Layout from '../components/layout';
import Overview from '../components/Overview';
import MainCategory from '../components/MainCategory';
import PropertyItem from '../components/PropertyItem';
import FunctionItem from '../components/FunctionItem';
import '../styles/main.scss';

var ApiPage =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ApiPage, _React$Component);

  function ApiPage() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ApiPage.prototype;

  _proto.render = function render() {
    // eslint-disable-line complexity
    var _this$props$location = this.props.location,
        pathname = _this$props$location.pathname,
        hash = _this$props$location.hash;
    var _this$props$data$apiP = this.props.data.apiPageJson,
        parentPid = _this$props$data$apiP.parentPid,
        title = _this$props$data$apiP.title,
        items = _this$props$data$apiP.items;
    var selectedNavItemId = "" + pathname.split('/').pop() + hash;
    var overview = items.filter(function (item) {
      return item.type === 'overview';
    });
    var staticProperies = items.filter(function (item) {
      return item.type === 'static-property';
    });
    var staticMethods = items.filter(function (item) {
      return item.type === 'static-method';
    });
    var instanceMethods = items.filter(function (item) {
      return item.type === 'instance-method';
    });
    var events = items.filter(function (item) {
      return item.type === 'event';
    });
    var typedef = items.filter(function (item) {
      return item.type === 'typedef';
    });
    var hasProperties = parentPid === 'typedef' ? !!overview[0].types.names.find(function (type) {
      return type === 'object';
    }) : false;
    return React.createElement(Layout, {
      tabIndex: 0,
      selectedNavItemId: selectedNavItemId
    }, React.createElement("header", null, React.createElement("h2", {
      className: "title"
    }, title)), React.createElement("article", null, overview.length ? React.createElement(Overview, {
      parentPid: parentPid,
      data: overview[0],
      hasProperties: hasProperties
    }) : null, staticProperies.length ? React.createElement(MainCategory, {
      title: "Static Properties"
    }, staticProperies.map(function (item, index) {
      return React.createElement(PropertyItem, {
        key: "static-method-" + index,
        data: item
      });
    })) : null, staticMethods.length ? React.createElement(MainCategory, {
      title: "Static Methods"
    }, staticMethods.map(function (item, index) {
      return React.createElement(FunctionItem, {
        key: "static-method-" + index,
        data: item
      });
    })) : null, instanceMethods.length ? React.createElement(MainCategory, {
      title: "Instance Methods"
    }, instanceMethods.map(function (item, index) {
      return React.createElement(FunctionItem, {
        key: "instance-method-" + index,
        data: item
      });
    })) : null, events.length ? React.createElement(MainCategory, {
      title: "Events"
    }, events.map(function (item, index) {
      return React.createElement(FunctionItem, {
        key: "event-" + index,
        data: item
      });
    })) : null, typedef.length ? React.createElement(MainCategory, {
      title: "Typedef"
    }, typedef.map(function (item, index) {
      return React.createElement(FunctionItem, {
        key: "" + index,
        data: item
      });
    })) : null));
  };

  return ApiPage;
}(React.Component);

export default ApiPage;
export var query = "2393403431";